<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <button type="button" class="in_back_btn" @click="backMyPage">
                    <img src="@/assets/user/line_back_ico_l.png" />
                    <span>BACK</span>
                </button>
                <p class="page_title">설문조사</p>
                <div class="board_wrap" id="servey_list">
                    <table class="survey_list">
                        <tbody>
                            <tr v-for="item in list.data">
                                <td>
                                    <router-link to="#" @click="moveDetail(item.idx)">
                                        <p>{{ item.title }}</p>
                                        <span>종료일 {{ dateFormat(item.endDate) }}</span>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <PageBtn :totalLength="list.length" :perPage="list.size" :current-page="list.currentPage"
                        @onPaging="handlePageChange">
                    </PageBtn>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="modal.content" :no="modal.cancle" :yes="modal.confirm"
        @close="modalClose">
    </ModalComponent>
</template>
<script lang="ts" config>
import {
    DataGrid,
    ModalComponent,
    HeaderLayout,
    GnbLayout,
    apiService,
    onMounted,
    reactive,
    router,
    PageBtn,
    dateFormat,
} from "@/BaseComponent";

export default {
    props: {},
    components: {
        ModalComponent,
        DataGrid,
        HeaderLayout,
        GnbLayout,
        PageBtn,
    },
    setup() {
        const state = reactive({
            isModalOpen: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancle: "" as string,
            actionCode: 0 as number
        });
        const list = reactive({
            data: [] as any,
            size: 12 as number,
            length: 0 as number,
            currentPage: 1 as number,
            totlapage: 0 as number,
            selected: [] as any[],
            fields: [
                {
                    key: "title",
                    label: "제목",
                    clickable: true,
                    class: "text-left text-content",
                    render: function (row: any) {
                        const date = new Date(row.endDate);

                        const year = date.getUTCFullYear().toString().slice(-2);
                        const month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
                        const day = ("0" + date.getUTCDate()).slice(-2);
                        return `<a><p>${row.title}</p>
                            <span>종료일 ${year}.${month}.${day}</span></a>`;
                    },
                },
            ],
        });
        const handlePageChange = (page: number) => {
            list.currentPage = page;
            getList();
        };

        onMounted(() => {
            getList();
        });

        const getList = async () => {
            let res = await apiService.survey.getList();
            if (res.returnCode === 0) {
                list.data = res.list;
                list.length = list.data.length;
                if (list.length === 0) {
                    state.isModalOpen = true;
                    modal.content = "참여가능한 설문이 없습니다.";
                    modal.confirm = "확인";
                    modal.cancle = "";
                    modal.actionCode = 1;
                }

            } else {
                state.isModalOpen = true;
                modal.content = res.description;
                modal.confirm = "확인";
                modal.cancle = "";
                modal.actionCode = 1;
            }
        };

        const moveDetail = (index: number) => {
            router.push({ path: "/survey/detail/" + index });
        };

        const backMyPage = () => {
            router.back();
        };

        const modalClose = (result: Boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.replace('/mypage');
                        break;

                    default:
                        break;
                }
            } else {
                switch (modal.actionCode) {
                    case 1:
                        router.replace('/mypage');
                        break;

                    default:
                        break;
                }
            }
        };
        return {
            state,
            modal,
            list,
            handlePageChange,
            moveDetail,
            backMyPage,
            modalClose,
            dateFormat,
        };
    },
};
</script>
<style scoped>
.board_wrap {
    min-height: calc(100vh - 200px);
}
</style>